/**
 * Pure (non-component) logic for the markets feed's zero-result empty state,
 * kept out of `empty-state.tsx` so that component file stays Fast-Refresh-safe
 * (only-export-components). See `EmptyState` for the rendered copy (MOR-652).
 */

/**
 * Which zero-result view the feed is showing. The copy is tailored per view so
 * an empty Ending-Soon or Resolved tab doesn't read as "create a market on the
 * Launchpad" — which only makes sense when there are genuinely no markets yet.
 */
export type MarketsEmptyVariant = 'default' | 'endingSoon' | 'resolved';

/**
 * `'filtered'` renders `<NoResults>` ("nothing matches your filters"); the rest
 * map to `<EmptyState variant>`.
 */
export type MarketsEmptyStateKind = MarketsEmptyVariant | 'filtered';

/**
 * Pick the zero-result empty state for the current feed view (MOR-652). Order
 * matters: an explicit filter/search wins ("nothing matches"), then the
 * Resolved tab and Ending-Soon sort each get their own copy, else the generic
 * "no markets yet" CTA.
 */
export function resolveMarketsEmptyVariant(args: {
  explicitFilterActive: boolean;
  isResolvedView: boolean;
  isEndingSoonSort: boolean;
}): MarketsEmptyStateKind {
  if (args.explicitFilterActive) return 'filtered';
  if (args.isResolvedView) return 'resolved';
  if (args.isEndingSoonSort) return 'endingSoon';
  return 'default';
}
